import {instance, requestNoSpinnerPromiseWrapper} from "./instance";

export function getIncidentsRequest(query) {
  return requestNoSpinnerPromiseWrapper(instance.get(`/incidents?${query}`));
}

export function getIncidentRequest(id) {
  return requestNoSpinnerPromiseWrapper(instance.get(`/incidents/${id}`));
}